import { CheckIcon, createTheme, Radio, rem } from '@mantine/core';

export default createTheme({
  colors: {
    primary: [
      '#effbeb',
      '#e1f2db',
      '#c3e3b8',
      '#a3d391',
      '#88c671',
      '#76bd5b',
      '#6db950',
      '#5ba340',
      '#4f9137',
      '#407d2a'
    ],
    secondary: [
      '#f3f3f6',
      '#e4e4e5',
      '#c7c7cd',
      '#a8a8b4',
      '#8e8d9f',
      '#7d7d92',
      '#75748d',
      '#63637a',
      '#58576e',
      '#4b4b62'
    ]
  },
  primaryColor: 'primary',
  black: '#141414',
  white: '#ffffff',
  fontFamily: 'Poppins Regular, sans-serif',
  fontFamilyMonospace: 'Poppins Regular, monospace',
  headings: { fontFamily: 'Poppins Medium, sans-serif' },
  fontSizes: {
    xs: rem(12),
    sm: rem(13),
    md: rem(14),
    lg: rem(15),
    xl: rem(16),
  },
  lineHeights: {
    xs: '1.4',
    sm: '1.45',
    md: '1.55',
    lg: '1.6',
    xl: '1.65',
  },
  components: {
    Radio: Radio.extend({
      defaultProps: {
        radius: 4,
        icon: CheckIcon,
        iconColor: 'white',
        size: 'sm'
      }
    })
  }
});